import { all, fork } from 'redux-saga/effects';

import { authSagaRequest } from './sagas/auth';
import { studentSagaRequest } from './sagas/student';
import { eventSagaRequest } from './sagas/event';

const rootSaga = function* () {
    yield all([fork(authSagaRequest), fork(studentSagaRequest), fork(eventSagaRequest)]);
};

export { rootSaga };
